(() => {
  if (customElements.get('google-review')) return;
  let apiReady;
  const places = new Map();

  function readCachedPlace(placeId) {
    try {
      return JSON.parse(sessionStorage.getItem(`placeDetails_${placeId}`));
    } catch (error) { return null; }
  }

  function loadApi(apiKey) {
    if (window.google?.maps?.places) return Promise.resolve();
    if (!apiReady) {
      apiReady = new Promise((resolve, reject) => {
        if (!apiKey) return reject(new Error('Review API not configured'));
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places`;
        script.onload = () => {
          window.googleMapsApiLoaded = true;
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    return apiReady;
  }

  function getPlace(placeId, apiKey) {
    if (places.has(placeId)) return places.get(placeId);
    const details = (async () => {
      const cached = readCachedPlace(placeId);
      if (cached?.rating && cached.cachedAt > Date.now() - 60 * 60 * 1000) return cached;
      await loadApi(apiKey);
      return new Promise((resolve, reject) => {
        const service = new google.maps.places.PlacesService(document.createElement('div'));
        service.getDetails({ placeId, fields: ['rating', 'user_ratings_total', 'url'] }, (place, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK) return reject(new Error(status));
          try { sessionStorage.setItem(`placeDetails_${placeId}`, JSON.stringify({ rating: place.rating, user_ratings_total: place.user_ratings_total, url: place.url, cachedAt: Date.now() })); } catch (error) { /* Optional cache. */ }
          resolve(place);
        });
      });
    })();
    places.set(placeId, details);
    return details;
  }

  customElements.define('google-review', class extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.placeId) return;
      // Render the last successful response immediately, including when it is
      // due for refresh. Failed API calls never remove the visible review proof.
      this.updateReview(readCachedPlace(this.dataset.placeId));
      getPlace(this.dataset.placeId, this.dataset.apiKey).then((place) => this.updateReview(place))
        .catch(() => { /* Keep the cached or editor-configured score and count. */ });
    }

    updateReview(place) {
      if (!this.isConnected || !Number.isFinite(place?.rating) || !(place.rating > 0 && place.rating <= 5) ||
        !Number.isInteger(place.user_ratings_total) || place.user_ratings_total <= 0) return;
      this.querySelector('.review-score').textContent = place.rating.toFixed(1);
      this.querySelector('.review-count').textContent = place.user_ratings_total;
      if (place.url) this.querySelector('.review-link').href = place.url;
      const label = this.querySelector('[data-review-label]');
      label.textContent = label.dataset.reviewLabel;
      this.querySelectorAll('.review-metrics').forEach((metric) => { metric.hidden = false; });
      const stars = this.querySelector('.review-stars');
      stars.hidden = false;
      stars.replaceChildren();
      for (let index = 0; index < 5; index++) {
        const star = document.createElement('span');
        star.className = 'star';
        star.textContent = index < Math.round(place.rating) ? '★' : '☆';
        stars.appendChild(star);
      }
    }
  });
})();
